import calculArrondi from '@/services/calcul/calculArrondi';
import { calculLigneCommandeRemise } from '@/services/devisCommandes/calcul/calculLigneCommandeRemise';
import { POURCENTAGE } from '@/configuration/devisConf';

export default function calculLigneCommandeNormal(ligneCommande) {
  if (ligneCommande === null) {
    return;
  }
  const { prixUnitaire, quantite } = ligneCommande;
  ligneCommande.totalAvantRemise = 0;
  ligneCommande.totalHt = 0;
  if (!prixUnitaire < 0 || prixUnitaire === undefined || !quantite < 0 || quantite === undefined) {
    return;
  }

  if (ligneCommande.uniteVente === POURCENTAGE) {
    ligneCommande.totalAvantRemise = (prixUnitaire * quantite) / 100;
  } else {
    ligneCommande.totalAvantRemise = calculArrondi(prixUnitaire * quantite);
  }

  calculLigneCommandeRemise(ligneCommande);
}
